import React from 'react'

export const Pramon = ({ widget: { id } }) => (
  <img src={`https://r.i0.cz/l.gif?s=pramon&v=1&e=view&t=${id}`} alt='Pramon'/>
)
